import {TbLayoutSidebarLeftExpand} from "react-icons/tb";
import {HiPlus, HiSearch} from "react-icons/hi";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {setIsChatbotSidebarCollapsed} from "../../../redux/slices/chat";

interface CollapsedSidebarProps {
  onCreateNewChatClick: () => void;
  onSearchChatClick: () => void;
}

const CollapsedSidebar: React.FC<CollapsedSidebarProps> = ({
  onCreateNewChatClick,
  onSearchChatClick,
}) => {
  const dispatch = useDispatch();
  const {
    isChatbotSidebarCollapsed
  } = useSelector((state?: any) => state.chatMessages);

  const expandChatbotSidebar = () => {
    dispatch(setIsChatbotSidebarCollapsed(false));
  }

  return (
    <div className="p-3 h-full flex flex-col">
      <button
        onClick={expandChatbotSidebar}
        className="p-0.5 sm:p-1 mt-1 sm:mt-2 mx-auto hover:bg-gray-200 dark:hover:bg-gray-700 rounded text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-white"
        title="Expand sidebar"
        style={{ cursor: isChatbotSidebarCollapsed ? 'e-resize' : 'default' }}
      >
        <TbLayoutSidebarLeftExpand className="w-5 h-5 sm:w-6 sm:h-6" />
      </button>

      <div className="flex flex-col space-y-2 mt-4">
        <button
          onClick={onCreateNewChatClick}
          className="group flex items-center mx-auto gap-2 p-1.5 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300 transition-colors duration-150"
          title="New Chat"
        >
          <HiPlus className="h-5 w-5 text-gray-500 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-400" />
          <span className="hidden">New Chat</span>
        </button>

        <button
          onClick={onSearchChatClick}
          className="group flex items-center mx-auto gap-2 p-1.5 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300 transition-colors duration-150"
          title="Search Chat"
        >
          <HiSearch className="h-5 w-5 text-gray-500 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-400" />
          <span className="hidden">Search Chat</span>
        </button>
        <div className="border-b pb-1 border-gray-200 dark:border-gray-700 mt-4"/>
      </div>
    </div>
  );
}

export default CollapsedSidebar;